module.exports = __webpack_public_path__ + "b3dcc078fabb000c3c8856a20d3a9bb1.svg";